import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './http'
import imageResizer from './imageResizer'
import '@/scss/styles.scss'
import VeeValidate from 'vee-validate'
import VueCroppie from 'vue-croppie'
import htmlToImage from 'html-to-image'
import VueScrollTo from 'vue-scrollto'
import './registerServiceWorker'

Vue.config.productionTip = false

Vue.use(VeeValidate)
Vue.use(VueCroppie)
Vue.use(htmlToImage)
Vue.use(VueScrollTo)

Object.defineProperties(Vue.prototype, {
  $http: {
    value: http
  },
  $imageResizer: {
    value: imageResizer
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
